const templateActionTypes =  {
    LOAD_SAVE_AS_TEMPLATE: "LOAD_SAVE_AS_TEMPLATE",
    CANCEL_SAVE_AS_TEMPLATE: "CANCEL_SAVE_AS_TEMPLATE",
    SAVING_TEMPLATE: "SAVING_TEMPLATE",
    SAVED_TEMPLATE: "SAVED_TEMPLATE",
    ERROR_SAVING_TEMPLATE: "ERROR_SAVING_TEMPLATE",
    CHANGE_TEMPLATE_FIELD_VALUE: "CHANGE_TEMPLATE_FIELD_VALUE"
};
export default templateActionTypes;